export default __webpack_public_path__ + "static/media/canecaGris.68fb7bb6.svg";